import { Body } from '@casavo/habitat'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import Icon from '@/components/Icon'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import { detailFacilityIcon, detailFeatures, detailFeaturesContainer, detailInfoBox } from './styles.css'

export type Characteristic = {
  amount: number | string
  icon: string
  title: string
  value: number | string
}

type Props = {
  characteristics: Characteristic[]
  className?: string
  rooms: Characteristic
}

const Characteristics: React.FC<Props> = ({ characteristics, className, rooms }) => {
  const { lang, t } = useTranslation()

  if (!characteristics) {
    return null
  }

  return (
    <div className={className}>
      <div
        className={sprinkles({
          paddingBottom: 's',
          textTransform: 'uppercase',
        })}
      >
        <Body noMargin size="m">
          {t('listing-detail:characteristics')}
        </Body>
      </div>
      <div className={detailInfoBox}>
        <div
          className={cn(
            detailFeaturesContainer,
            sprinkles({
              flexDirection: 'row',
            })
          )}
        >
          {rooms.value && (
            <div className={detailFeatures}>
              <Body noMargin color="root.neutral.500" size="s">
                {t(`common:${rooms.title}`)}
              </Body>

              <div
                className={sprinkles({
                  alignItems: 'center',
                  display: 'flex',
                })}
              >
                <div className={sprinkles({ marginRight: 'xs' })}>
                  <Body noMargin strong size="l">
                    {rooms.value}
                  </Body>
                </div>
                <Icon.Rooms />
              </div>
            </div>
          )}
          {characteristics.map((item, index) =>
            item.value ? (
              <div key={index} className={detailFeatures}>
                <Body noMargin color="root.neutral.500" size="s">
                  {t(`listing-detail:${item.title}`)}
                </Body>
                <div
                  className={sprinkles({
                    alignItems: 'center',
                    display: 'flex',
                  })}
                >
                  <div className={sprinkles({ marginRight: 'xs' })}>
                    <Body noMargin strong size="l">
                      {item.amount}
                    </Body>
                  </div>
                  {item.icon && (
                    <div
                      className={detailFacilityIcon}
                      style={{
                        background: `transparent url(/lisa/images/property-details-icons/${item.icon}.svg) no-repeat center center`,
                      }}
                    />
                  )}
                </div>
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  )
}
export default Characteristics
